import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tags?: React.ReactNode;
  extra?: React.ReactNode;
  actions?: React.ReactNode;
  breadcrumb?: string;
  style?: React.CSSProperties;
}

export function PageHeader({
  title,
  subtitle,
  tags,
  extra,
  actions,
  breadcrumb,
  style,
}: PageHeaderProps): React.ReactElement {
  return (
    <div style={{
      padding: '18px 24px 14px',
      borderBottom: '1px solid #e4e1d8',
      background: '#ffffff',
      ...style,
    }}>
      {breadcrumb && (
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1, color: '#7a756c', marginBottom: 4 }}>
          {breadcrumb}
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24, fontWeight: 900, fontStyle: 'italic', letterSpacing: -0.8, color: '#0b0b0d', lineHeight: 1 }}>
            {title}
          </h1>
          {subtitle && (
            <div style={{ fontSize: 12, color: '#7a756c', fontWeight: 500, marginTop: 6 }}>{subtitle}</div>
          )}
        </div>
        {(actions || extra) && (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {actions}
            {extra}
          </div>
        )}
      </div>
      {tags && <div style={{ marginTop: 8 }}>{tags}</div>}
    </div>
  );
}
